import { rootApi } from "../../api/rootApi";

export const couponRedemptionsApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchAllCouponRedemptions: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/couponRedemption`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    getAllRedeemedCoupons: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/app/couponRedemption/`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
  }),
});

export const {
  useFetchAllCouponRedemptionsMutation,
  useGetAllRedeemedCouponsMutation,
} = couponRedemptionsApi;
